import { getRangeValue, getTermValue, resetTerms } from '../../../../JsonQuery';
import { TTagsManager } from '../../types/tag';
import { EWCCount, EWCType } from '../../../../api-models/common/json_query';

const ID = 'wcCount' as const;

export const wcCountTagManager: TTagsManager = {
  id: ID,
  extractTagsFromJsonQuery: ({ jsonQuery }) => {
    const wcType = getTermValue('wc_type')(jsonQuery) || EWCType.Any;
    const wcCount = getRangeValue('wc')(jsonQuery)?.gte || EWCCount.Any;

    if (
      (wcCount === EWCCount.One && wcType === EWCType.Any) ||
      (wcCount !== EWCCount.Any && wcCount !== EWCCount.One)
    ) {
      const value = wcCount || EWCCount.One;

      return [{ label: `Санузлов минимум ${value}`, value: 'wcCount' }];
    }

    return null;
  },
  modifyJsonQueryByRemovingTag: ({ jsonQuery }) => resetTerms(['wc'])(jsonQuery),
};
